<template>
    <el-dialog class="el-dialogs" :title="title" width="400px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="100px">
            <el-form-item label="节点名称：" prop="knowledgeName">
                <el-input v-model.trim="searchForm.knowledgeName" maxlength="20"
                          placeholder="请输入节点名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="来源：" prop="knowledgeSource">
                <el-input v-model.trim="searchForm.knowledgeSource" maxlength="500"
                          type="textarea" :rows="1"
                          placeholder="请输入来源(限500字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="knowledgeState">
                <el-switch
                        v-model="searchForm.knowledgeState"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model.trim="searchForm.remark" maxlength="500"
                          type="textarea" :rows="5" resize="none"
                          placeholder="请输入备注(限500字)"
                          clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addNode",
    data() {
        return {
            title: '新增节点',
            visible: false,
            searchForm: {
                id: '',
                knowledgeName: '',
                knowledgeSource: '',
                knowledgeState: '0',
                remark: '',
            },
            rules: {
                knowledgeName: [
                    {required: true, message: '请输入节点名称', trigger: 'blur'}
                ],
                knowledgeSource: [
                    {required: true, message: '请输入来源', trigger: 'blur'}
                ],
            },
        }
    },

    methods: {
        init(type, row) {
            this.visible = true
            this.$nextTick(() => {
                this.searchForm.id = ''
                this.$refs.searchForm.resetFields();
            })
            if (type == 'view') {
                this.title = '新增节点'
            }
            if (type == 'edit') {
                this.title = '编辑节点'
                this.getDetail(row)
            }
        },

        //获取详情
        getDetail(row) {
            this.$axios(this.api.academic.knowledgenodeGetById + row.id).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        this.searchForm[key] = data.data[key]
                    })
                }
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.knowledgenodeUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.knowledgenodeSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>